'use strict';

module.exports = function () {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });

  return deferred;
};


/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/emarsys-integration-client/dist/defer.js
 ** module id = 7
 ** module chunks = 0 1
 **/